<!-- eslint-disable -->
<template>
  <v-card class="forgot-card" elevation="2" max-width="440" mx-auto>
    <v-card-title class="text-h6 pa-6 pb-2">
      {{ $t('auth.resetPassword') }}
    </v-card-title>

    <v-card-text class="pa-6 pt-2">

      <!-- Step 1: enter email -->
      <div v-if="step === 1">
        <p class="text-body-2 text-grey mb-4">{{ $t('auth.resetStep1Info') }}</p>
        <v-text-field
          v-model="email"
          :label="$t('auth.email')"
          type="email"
          variant="outlined"
          density="compact"
          class="mb-3"
          @keydown.enter="requestCode"
        />
        <v-alert v-if="error" type="error" variant="tonal" density="compact" class="mb-3">
          {{ error }}
        </v-alert>
        <v-btn
          color="primary"
          block
          :loading="loading"
          @click="requestCode"
        >
          {{ $t('auth.sendCode') }}
        </v-btn>
      </div>

      <!-- Step 2: enter code + new password -->
      <div v-if="step === 2">
        <p class="text-body-2 text-grey mb-4">{{ $t('auth.resetStep2Info') }}</p>
        <v-text-field
          v-model="code"
          :label="$t('auth.code')"
          variant="outlined"
          density="compact"
          maxlength="6"
          class="mb-3"
        />
        <v-text-field
          v-model="newPassword"
          :label="$t('auth.newPassword')"
          type="password"
          variant="outlined"
          density="compact"
          class="mb-3"
        />
        <v-text-field
          v-model="confirmPassword"
          :label="$t('auth.confirmPassword')"
          type="password"
          variant="outlined"
          density="compact"
          class="mb-3"
          @keydown.enter="resetPassword"
        />
        <v-alert v-if="error" type="error" variant="tonal" density="compact" class="mb-3">
          {{ error }}
        </v-alert>
        <v-btn
          color="primary"
          block
          :loading="loading"
          @click="resetPassword"
        >
          {{ $t('auth.setNewPassword') }}
        </v-btn>
      </div>

      <!-- Step 3: done -->
      <div v-if="step === 3" class="text-center py-4">
        <v-icon size="48" color="success" class="mb-3">mdi-check-circle</v-icon>
        <p class="text-body-1 mb-4">{{ $t('auth.resetSuccess') }}</p>
        <v-btn color="primary" @click="$router.push('/login')">
          {{ $t('auth.backToLogin') }}
        </v-btn>
      </div>

      <!-- Back to login -->
      <div v-if="step !== 3" class="text-center mt-4">
        <router-link to="/login" class="text-caption text-grey">
          {{ $t('auth.backToLogin') }}
        </router-link>
      </div>

    </v-card-text>
  </v-card>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '../services/api'

const { t } = useI18n()

const step = ref(1)
const email = ref('')
const code = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const error = ref(null)
const loading = ref(false)

const requestCode = async () => {
  error.value = null
  if (!email.value.trim()) {
    error.value = t('auth.emailRequired')
    return
  }
  loading.value = true
  try {
    await api.post('/auth/forgot-password', { email: email.value.trim() })
    step.value = 2
  } catch (e) {
    error.value = t('auth.serverError')
  } finally {
    loading.value = false
  }
}

const resetPassword = async () => {
  error.value = null
  if (!code.value.trim()) {
    error.value = t('auth.codeRequired')
    return
  }
  if (!newPassword.value || newPassword.value.length < 8) {
    error.value = t('auth.passwordTooShort')
    return
  }
  if (newPassword.value !== confirmPassword.value) {
    error.value = t('auth.passwordMismatch')
    return
  }
  loading.value = true
  try {
    const res = await api.post('/auth/reset-password', {
      email: email.value.trim(),
      code: code.value.trim(),
      newPassword: newPassword.value
    })
    if (res.data.success) {
      step.value = 3
    } else {
      error.value = res.data.error || t('auth.serverError')
    }
  } catch (e) {
    error.value = e.response?.data?.error || t('auth.serverError')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.forgot-card {
  margin: 2rem auto;
}
</style>